import { LandingHeader } from "../components/landing/LandingHeader";
import { LandingFooter } from "../components/landing/LandingFooter";
import { HeroSection } from "../components/landing/HeroSection";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { ComparisonSection } from "../components/landing/ComparisonSection";
import { HowItWorksSection } from "../components/landing/HowItWorksSection";
import { CTASection } from "../components/landing/CTASection";

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <LandingHeader />
      <main className="flex-1">
        <HeroSection />
        <HowItWorksSection />
        <FeaturesSection />
        <ComparisonSection />
        <CTASection />
      </main>
      <LandingFooter />
    </div>
  );
}
